import safeGet from 'lodash/get';
import { ISubOrder, PolicyInfoItem } from 'types/order';

export const getClientWidth = () => {
    const doc = window.document;
    const docEl = doc.documentElement;
    if (window.top !== window.self && /iphone|ipad/gi.test(navigator.userAgent)) {
        // 解决ios嵌套iframe宽度不正确的问题
        // 父级容器会通过url-query-string的方式告诉正确的宽度
        let m = window.self.location.href.match(/width=(\d+)/);
        if (m && m[1]) {
            return Number(m[1]);
        }
    }
    return docEl.getBoundingClientRect().width;
};

export function ellipsisStr(text: string, count: number, symbol = '...'): string {
    if (text.length > count) {
        return `${text.substring(0, count)}${symbol}`;
    }

    return text;
}

// 判断是否有退货运费险 返回 undefined
export function orderSupportRetIns(subOrderArr: ISubOrder): boolean {
    return (
        ((subOrderArr && subOrderArr.policy_info) || []).some(
            (item) => item.policy_type === 'RETURN_FREIGHT'
        ) || false
    );
}
export function getRetInsInfo(detailInfo: { policy_info: PolicyInfoItem[] }) {
    if (!detailInfo) {
        return {};
    }
    const {
        ins_policy_no: insPolicyNo,
        status,
        status_desc: statusDesc,
        policy_type: policyType,
        policy_amount: policyAmount
    } = (detailInfo.policy_info || []).find((item) => item.policy_type === 'RETURN_FREIGHT') || {};
    return {
        insPolicyNo,
        status,
        statusDesc,
        policyType,
        policyAmount
    };
}
// 写了两个相同的是因为后端接口有的时候是大写有的时候是小写
interface Detailinfo {
    InsProduct?: { returnfreight2020v1: 0 | 1 };
}
interface DetailInfo {
    insProduct?: { returnfreight2020v1: 0 | 1 };
}
export function supportRetIns(detailInfo: DetailInfo | Detailinfo, key = 'insProduct'): boolean {
    return Boolean(safeGet(detailInfo, `${key}.returnfreight2020v1`, false));
}
